import { inject, Service, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { LocalStorageKey } from '@core/types/local-storage.type';

@Service()
export class LocalStorageService {
  private readonly isBrowser = isPlatformBrowser(inject(PLATFORM_ID));

  public set(key: LocalStorageKey, value: unknown): void {
    if (!this.isBrowser) return;
    localStorage.setItem(key, JSON.stringify(value));
  }

  get<T>(key: LocalStorageKey): T | undefined {
    if (!this.isBrowser) return undefined;
    const value = localStorage.getItem(key);

    switch (value?.toLocaleLowerCase()) {
      case 'true':
        return true as unknown as T;
      case 'false':
        return false as unknown as T;
      default:
        return value ? (JSON.parse(value) as T) : undefined;
    }
  }

  remove(key: LocalStorageKey): void {
    if (!this.isBrowser) return;
    localStorage.removeItem(key);
  }

  clear(): void {
    if (!this.isBrowser) return;
    localStorage.clear();
  }
}
